import React, { useContext } from 'react'
import './style/Q3.css'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import YesOrNoQuestion from '../YesOrNoQuestion'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import StepCounter from '../StepCounter'
import gif2 from './assets/03_box 2.gif'
import jpg2 from './assets/static/03_box-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q2() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()
    return (
        <>
            <div className="picHold hid vis">
                <img className="gif2" src={settings.isAnimationPause ? jpg2 : gif2} />
            </div>
            <Headling text={translate('Fees Aren’t for Me')} />
            <Subtitle text={translate('Am I exempt from checking account fees at my current bank?')} />
            <YesOrNoQuestion onYesClick={() => {
                setNewAnswer({
                    2: 1
                })
                history.push('/Q/3')
                ReactPixel.trackCustom('comission_yes', '');
            }}
                onNoClick={() => {
                    setNewAnswer({
                        2: 0
                    })
                    history.push('/Q/3')
                    ReactPixel.trackCustom('comission_no', '');
                }} />
            <StepCounter />

        </>
    )
}



export default Q2

